module.exports = __webpack_public_path__ + "img/129.1.3ea70d69.jpg";